import type { Step } from "react-joyride";

/**
 * Versione 2 (2026-09-12): targhetta dello stato invio, cestino delle bozze,
 * vista elenco/schede.
 *
 * I passi su targhetta e cestino sono agganciati alla prima riga utile e
 * compaiono in due varianti — `-card` (telefono) e `-riga` (tabella desktop):
 * OnboardingTour tiene quella davvero visibile e scarta l'altra.
 */
export const praticheListVersion = 2;

export const praticheListSteps: Step[] = [
  {
    target: '[data-tour="pratiche-search"]',
    title: "Cerca una pratica",
    content: (
      <p>
        Cognome del cliente o nome della pratica. La ricerca parte con{" "}
        <strong>Cerca</strong>.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratiche-stage-filter"]',
    title: "Filtra per stato",
    content: (
      <p>
        Bozza, In lavorazione, Attivata… Per tornare a vedere tutto scegli{" "}
        <em>Tutti gli stati</em>.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="lista-vista"]',
    title: "Elenco o schede",
    content: (
      <p>
        Due modi di vedere le stesse pratiche. Sul telefono sono sempre schede.
      </p>
    ),
    placement: "bottom",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratiche-stato-invio-card"]',
    title: "A che punto è l'invio",
    content: (
      <p>
        Sotto lo stato, una targhetta dice se la pratica è pronta per partire,
        cosa le manca, o se va portata a mano sul portale del fornitore.
      </p>
    ),
    placement: "left",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratiche-stato-invio-riga"]',
    title: "A che punto è l'invio",
    content: (
      <p>
        Sotto lo stato, una targhetta dice se la pratica è pronta per partire,
        cosa le manca, o se va portata a mano sul portale del fornitore.
      </p>
    ),
    placement: "right",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratiche-table"]',
    title: "Apri la scheda",
    content: (
      <p>
        Un clic sulla riga apre la pratica: cliente, POD o PDR, offerta,
        commissione, bollette e moduli.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratiche-cestino-card"]',
    title: "Cancellare una bozza",
    content: (
      <p>
        Il cestino compare sulle sole pratiche in <strong>Bozza</strong>. La
        cancellazione non si torna indietro, quindi viene chiesta una conferma.
      </p>
    ),
    placement: "left",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratiche-cestino-riga"]',
    title: "Cancellare una bozza",
    content: (
      <p>
        Il cestino compare sulle sole pratiche in <strong>Bozza</strong>. La
        cancellazione non si torna indietro, quindi viene chiesta una conferma.
      </p>
    ),
    placement: "left",
    skipBeacon: true,
  },
  {
    target: '[data-tour="pratiche-pagination"]',
    title: "Paginazione",
    content: (
      <p>
        Venti pratiche per pagina: <strong>Precedente</strong> e{" "}
        <strong>Successiva</strong> per scorrere.
      </p>
    ),
    placement: "top",
    skipBeacon: true,
  },
];
